<template src="./template.html"></template>

<script>
  import { mapActions, mapState } from 'vuex'
  import MetaPage from '@/components/layout/MetaPage'

  export default {
    name: 'ForgotPasswordPage',
    components: {
      MetaPage,
    },
    metaInfo() {
      return {
        title: this.$t('meta.forgot-password.title'),
      }
    },
    data() {
      return {
        email: '',
      }
    },
    computed: {
      ...mapState('auth', [
        'errors',
        'pending',
        'message',
      ]),
    },
    destroyed() {
      this.clearAuthError()
      this.clearMessage()
    },
    methods: {
      ...mapActions('auth', [
        'forgotPassword',
        'clearAuthError',
        'clearMessage',
      ]),
      onSubmit() {
        this.forgotPassword({ email: this.email }).then(_ => {
          if (this.errors.length) return false
          this.$nextTick(() => {
            this.email = ''
            this.$refs.form.reset()
          })
        })
      },
    },
  }
</script>
